import { Button } from 'antd';
import { appleAuthProvider, googleAuthProvider } from '../../../auth/firebaseAuth';
import { AppleSVG, GoogleSVG } from '../../../assets/svg/icon';
import React, { useEffect } from 'react';
import { GoogleAuthProvider } from 'firebase/auth';
import Icon, { MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import GoogleOneTapLogin from 'react-google-one-tap-login';
import { IGoogleCallbackResponse } from 'react-google-one-tap-login/dist/types/types';
import { env } from '../../../configs/EnvironmentConfig';
import { useAuthState } from '../../../redux/selector';
import { AuthResult, useAuthMutation } from '../../../hooks/Auth';
import { AuthProvider } from '@firebase/auth/dist/node-esm';

interface SocialLoginProps {
  onResult?: (result: AuthResult) => void;
}

const SocialLogin: React.FC<SocialLoginProps> = ({ onResult }) => {
  const { loading } = useAuthState();
  const { useSignInWithPopup, useSignInWithCredential } = useAuthMutation();
  const popupLogin = async (provider: AuthProvider) => {
    const result = await useSignInWithPopup.mutateAsync(provider);
    onResult && onResult(result);
  };
  const oneTapLogin = async (response: IGoogleCallbackResponse) => {
    const credential = GoogleAuthProvider.credential(response.credential);
    const result = await useSignInWithCredential.mutateAsync(credential);
    onResult && onResult(result);
  };
  useEffect(() => {
    if (loading) {
      // Dismiss one tap login after the user chose email login.
      window?.google?.accounts?.id?.cancel();
    }
    return () => {
      // Dismiss one tap login when leaving the page.
      window?.google?.accounts?.id?.cancel();
    };
  }, [loading]);
  return (
    <>
      <GoogleOneTapLogin
        googleAccountConfigs={{
          client_id: env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
          // Display "Use Forest with Google" instead of "Login to Forest with Google".
          context: 'use',
          callback: oneTapLogin,
        }}
      />
      <Button
        size="large"
        onClick={() => popupLogin(googleAuthProvider)}
        className="label-s d-flex align-items-center border-content-secondary"
        disabled={loading}
        block
      >
        <Icon component={GoogleSVG} />
        <div className="flex-grow-1">Continue with Google</div>
      </Button>
      <Button
        size="large"
        className="mt-4 label-s d-flex align-items-center border-content-secondary"
        disabled={loading}
        onClick={() => popupLogin(appleAuthProvider)}
        block
      >
        <Icon component={AppleSVG} />
        <div className="flex-grow-1">Continue with Apple</div>
      </Button>
      <Link to="/auth/email-link">
        <Button
          size="large"
          className="mt-4 label-s d-flex align-items-center border-content-secondary"
          disabled={loading}
          block
        >
          <MailOutlined className="text-content-secondary" />
          <div className="flex-grow-1">Email link</div>
        </Button>
      </Link>
    </>
  );
};

export default SocialLogin;
